import React from "react";
import { createBrowserHistory } from "history";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import privateRoutes from "@/routes/private";
import publicRoutes from "@/routes/public";

// Custom Components
import PrivatePage from "@/components/PrivatePage";
import ScrollToTop from "@/components/ScrollToTop";
import UserProvider from "@/components/UserContext/UserProvider";
import MapConfigProvider from "@/components/MapConfigContext/MapConfigProvider";
import ThemeProvider from "@/components/ThemeContext/ThemeProvider";
import SnackbarProvider from "@/ui/SnackbarContext/SnackbarProvider";
import SnackbarContainer from "@/ui/SnackbarContext/SnackbarContainer";
import DialogProvider from "@/ui/DialogContext/DialogProvider";
import DialogContainer from "@/ui/DialogContext/DialogContainer";
import LoaderProvider from "@/components/LoaderContext/LoaderProvider";
import LoaderContainer from "@/components/LoaderContext/LoaderContainer";
import OperationsProvider from "@/components/OperationsContext/OperationsProvider";


var history = createBrowserHistory();

class App extends React.Component {
  render() {
    return (
      <ThemeProvider>
        <UserProvider>
          <OperationsProvider>
            <SnackbarProvider>
              <LoaderProvider>
                <MapConfigProvider>
                  <DialogProvider>
                    <BrowserRouter basename={process.env.REACT_APP_DEPLOYFOLDER}>
                      <ScrollToTop>
                        <Routes>
                          {publicRoutes.map((prop, key) => (
                            <Route path={prop.path} key={key} element={React.createElement(prop.component)} />
                          ))}
                          {privateRoutes.map((prop, key) => (
                            <Route path={prop.path} key={key} element={<PrivatePage>{prop.component}</PrivatePage>} />
                          ))}
                        </Routes>
                      </ScrollToTop>
                      <DialogContainer />
                    </BrowserRouter>
                  </DialogProvider>
                </MapConfigProvider>
                <LoaderContainer />
                <SnackbarContainer />
              </LoaderProvider>
            </SnackbarProvider>
          </OperationsProvider>
        </UserProvider>
      </ThemeProvider>
    );
  }
}

export default App;
